import { connect } from 'react-redux'
import MainMenuPublic from './MainMenuPublic'

const mapStateToProps = ({
  mainMenu: {
    default: { tradeMenu, categoryMenu }
  }
}) => ({
  tradeMenu,
  categoryMenu
})

export default connect(mapStateToProps)(MainMenuPublic)



// WEBPACK FOOTER //
// ./src/App/MainMenu/MainMenuPublicContainer.js